import type { LegalSection } from '../legalDocuments.constants'
import { WC2026_ORG_BILLING_TERMS_SECTION } from '../../../shared/constants/wc2026OrgBillingDisclosure.constants'

const DE_PRIVACY_POLICY_SECTIONS: readonly LegalSection[] = [
  {
    title: 'Einleitung',
    paragraphs: [
      'Zporti („wir“, „uns“ oder „unser“) betreibt die mobile und webbasierte Anwendung Zporti (der „Dienst“). Diese Datenschutzerklärung beschreibt, wie wir Informationen erheben, verwenden und weitergeben, wenn Sie den Dienst nutzen.',
      'Durch die Nutzung des Dienstes stimmen Sie dieser Richtlinie zu. Wenn Sie nicht einverstanden sind, nutzen Sie den Dienst bitte nicht.',
    ],
  },
  {
    title: 'Informationen, die wir erheben',
    paragraphs: [
      'Konto- und Profilinformationen: wie Name, E-Mail-Adresse, Benutzername, Avatar- oder Profilbildauswahl und ähnliche Angaben, die Sie bei der Erstellung oder Aktualisierung Ihres Kontos bereitstellen.',
      'Authentifizierungsdaten: Wir nutzen Supabase-Authentifizierung und können je nach Plattform und Version E-Mail-Anmeldung, OAuth-Anbieter (z. B. Google oder Facebook) und Gast-Sitzungen unterstützen.',
      'Von Ihnen erstellte Inhalte: wie Sportvorhersagen, Challenges, Gruppenmitgliedschaften, Freundschaftsverbindungen, Einladungen und Nachrichten, die Sie über Kontakt- oder Supportformulare senden.',
      'Nutzungs- und Geräteinformationen: wie App-Ereignisse, ungefähre Standortdaten aus der IP-Adresse, sofern zutreffend, Gerätetyp, Betriebssystem und Diagnosedaten, um den Dienst sicher und zuverlässig zu betreiben.',
    ],
  },
  {
    title: 'Cookies, Analysen und Einwilligung',
    paragraphs: [
      'Im Web verwenden wir essenzielle Cookies bzw. Speicher für Authentifizierung, Sicherheit und den Betrieb der Kernfunktionen.',
      'Nicht essenzielle Analysen sind standardmäßig deaktiviert, bis Sie Ihre Einwilligung erteilen. Sie können diese Einstellung später in den Datenschutzeinstellungen der App ändern.',
      'Wenn aktiviert, können Analyseanbieter pseudonymisierte Nutzungsereignisse und begrenzte Kontometadaten verarbeiten, um uns bei der Verbesserung von Produktqualität und Zuverlässigkeit zu unterstützen.',
    ],
  },
  {
    title: 'Marketing-Kommunikation',
    paragraphs: [
      'Marketing-E-Mails sind opt-in. Wir senden Marketing-Kommunikation nur, wenn Sie aktiv zustimmen.',
      'Sie können Ihre Marketing-Einwilligung jederzeit in den Datenschutzeinstellungen widerrufen.',
      'Wenn Sie ein Konto erstellen, speichern wir Zeitpunkt und Richtlinienversion für die optionale Marketing-Einwilligung sowie für Ihre Annahme unserer Nutzungsbedingungen und Datenschutzerklärung, damit wir bei Bedarf nachweisen können, wozu Sie zugestimmt haben.',
    ],
  },
  {
    title: 'Wie wir Informationen verwenden',
    paragraphs: [
      'Wir verwenden die oben genannten Informationen, um den Dienst bereitzustellen und zu verbessern, Nutzer zu authentifizieren, Ihre Erfahrung zu personalisieren, Challenges und Bestenlisten zu betreiben, dienstbezogene Mitteilungen zu senden, die Nutzung aggregiert auszuwerten, Betrug und Missbrauch zu verhindern und gesetzlichen Pflichten nachzukommen.',
    ],
  },
  {
    title: 'Wie wir Informationen weitergeben',
    paragraphs: [
      'Wir geben Informationen an Dienstleister weiter, die uns beim Hosting des Dienstes, beim Versand von E-Mails, bei der Analyseverarbeitung oder bei ähnlichen Funktionen unterstützen, vorbehaltlich angemessener Schutzmaßnahmen.',
      'Wir können Informationen offenlegen, wenn dies gesetzlich vorgeschrieben ist, um unsere Rechte und die der Nutzer zu schützen, oder im Zusammenhang mit einer Fusion oder dem Verkauf von Vermögenswerten (mit Benachrichtigung, sofern erforderlich).',
      'Andere Nutzer können Informationen sehen, die Sie in der App sichtbar machen (z. B. Anzeigename, Avatar und Challenge-bezogene Aktivität), entsprechend den Produktfunktionen.',
    ],
  },
  {
    title: 'Aufbewahrung',
    paragraphs: [
      'Wir bewahren Informationen auf, solange Ihr Konto aktiv ist und soweit dies zur Bereitstellung des Dienstes, zur Erfüllung rechtlicher Pflichten, zur Beilegung von Streitigkeiten und zur Durchsetzung unserer Vereinbarungen erforderlich ist.',
    ],
  },
  {
    title: 'Ihre Wahlmöglichkeiten und Rechte',
    paragraphs: [
      'Je nach Ihrem Wohnort können Sie Rechte haben, auf Ihre personenbezogenen Daten zuzugreifen, sie zu berichtigen, zu löschen oder zu exportieren oder bestimmten Verarbeitungen zu widersprechen oder sie einzuschränken.',
      'Die Datenschutzeinstellungen in der App umfassen Kontolöschungsanfragen, Marketing-Einwilligungssteuerung und den Download eines Datenexports, sofern verfügbar.',
      'Sie können uns auch unter info@zporti.com kontaktieren. Wir müssen Ihre Anfrage möglicherweise verifizieren, bevor wir antworten.',
    ],
  },
  {
    title: 'Kinder',
    paragraphs: [
      'Der Dienst richtet sich nicht an Kinder unter 13 Jahren (oder das in Ihrer Region vorgeschriebene Mindestalter). Wir erheben wissentlich keine personenbezogenen Daten von Kindern.',
    ],
  },
  {
    title: 'Änderungen',
    paragraphs: [
      'Wir können diese Datenschutzerklärung von Zeit zu Zeit aktualisieren. Die aktualisierte Version veröffentlichen wir auf dieser Seite und passen das Gültigkeitsdatum entsprechend an.',
    ],
  },
  {
    title: 'Kontakt',
    paragraphs: [
      'Fragen zu dieser Richtlinie: info@zporti.com',
    ],
  },
]

const DE_DATA_DELETION_SECTIONS: readonly LegalSection[] = [
  {
    title: 'Überblick',
    paragraphs: [
      'Sie können die Löschung personenbezogener Daten beantragen, die mit Ihrem Zporti-Konto verknüpft sind. Diese Seite beschreibt, wie Sie einen solchen Antrag stellen und was Sie erwarten können.',
    ],
  },
  {
    title: 'So beantragen Sie die Löschung',
    paragraphs: [
      'Nutzen Sie die Datenschutzeinstellungen in der App, um die Kontolöschung aus Ihrer authentifizierten Sitzung heraus zu beantragen.',
      'Oder senden Sie eine E-Mail an info@zporti.com von der mit Ihrem Zporti-Konto verknüpften E-Mail-Adresse (oder geben Sie die Kontakt-E-Mail und weitere Angaben zur Identifizierung Ihres Profils eindeutig an).',
      'Verwenden Sie den Betreff „Data deletion request“. Wir können Sie bitten, Ihre Identität zu bestätigen, bevor wir den Antrag bearbeiten.',
      'Sie können auch eine Kopie Ihrer Kontodaten in den Datenschutzeinstellungen der App herunterladen.',
    ],
  },
  {
    title: 'Was wir löschen',
    paragraphs: [
      'Nach der Verifizierung löschen oder anonymisieren wir personenbezogene Daten, die mit Ihrem Konto verknüpft sind, sofern deren Aufbewahrung nicht aus rechtlichen, sicherheitsbezogenen oder streitbeilegungsbezogenen Gründen erforderlich ist.',
      'Einige Informationen können für einen begrenzten Zeitraum in Backups verbleiben, bis diese rotiert werden, oder wenn die Aufbewahrung gesetzlich vorgeschrieben ist.',
    ],
  },
  {
    title: 'Bearbeitungsfristen',
    paragraphs: [
      'Wir bemühen uns, verifizierte Anfragen innerhalb einer angemessenen Frist und innerhalb der in Ihrer Region geltenden gesetzlichen Fristen zu beantworten.',
    ],
  },
  {
    title: 'Kontakt',
    paragraphs: [
      'Fragen zur Datenlöschung: info@zporti.com',
    ],
  },
]

const DE_TERMS_OF_SERVICE_SECTIONS: readonly LegalSection[] = [
  {
    title: 'Vereinbarung',
    paragraphs: [
      'Diese Nutzungsbedingungen („Bedingungen“) regeln Ihren Zugang zu und Ihre Nutzung der mobilen und webbasierten Anwendung Zporti (der „Dienst“), die von Zporti („wir“, „uns“ oder „unser“) betrieben wird.',
      'Durch die Erstellung eines Kontos, den Zugriff auf oder die Nutzung des Dienstes stimmen Sie diesen Bedingungen zu. Wenn Sie nicht einverstanden sind, nutzen Sie den Dienst nicht.',
      'Bei der Registrierung bestätigen Sie die Annahme dieser Bedingungen und unserer Datenschutzerklärung getrennt von einer optionalen Einwilligung zu Marketing-E-Mails.',
    ],
  },
  {
    title: 'Der Dienst',
    paragraphs: [
      'Zporti bietet ein soziales Sportvorhersage- und Challenge-Erlebnis: Sie können mit Freunden Challenges erstellen oder beitreten, Vorhersagen abgeben, Ergebnisse und Bestenlisten einsehen und verwandte Funktionen nutzen, die wir im Laufe der Zeit hinzufügen oder ändern können.',
      'Wir können Teile des Dienstes mit angemessener Vorankündigung, soweit praktikabel, ändern, aussetzen oder einstellen. Wir garantieren keinen unterbrechungsfreien oder fehlerfreien Betrieb.',
    ],
  },
  {
    title: 'Berechtigung und Konten',
    paragraphs: [
      'Sie müssen das in Ihrer Region für die Nutzung des Dienstes erforderliche Mindestalter erfüllen (in der Regel mindestens 13 Jahre, oder höher, wenn das lokale Recht dies vorschreibt).',
      'Sie sind für die Richtigkeit der von Ihnen bereitgestellten Informationen und für die Sicherheit Ihrer Anmeldedaten verantwortlich. Informieren Sie uns umgehend über den unten genannten Kontakt, wenn Sie einen unbefugten Zugriff auf Ihr Konto vermuten.',
    ],
  },
  {
    title: 'Zulässige Nutzung',
    paragraphs: [
      'Sie verpflichten sich, den Dienst nicht missbräuchlich zu nutzen. Sie dürfen beispielsweise nicht: gegen Gesetze verstoßen; andere belästigen, missbrauchen oder schädigen; unbefugten Zugriff auf unsere Systeme oder die Konten anderer Nutzer versuchen; den Dienst scrapen oder überlasten; Malware verbreiten; bei Challenges oder Ergebnissen betrügen, manipulieren oder stören; oder den Dienst zum Versand von Spam oder irreführenden Mitteilungen nutzen.',
      'Wir können Konten untersuchen und sperren oder kündigen, die gegen diese Bedingungen verstoßen oder den Dienst oder Nutzer gefährden.',
    ],
  },
  {
    title: 'Nutzerinhalte',
    paragraphs: [
      'Sie behalten Rechte an Inhalten, die Sie einreichen (wie Profilinformationen, Nachrichten und Challenge-Aktivität). Sie gewähren uns eine nicht-exklusive Lizenz, diese Inhalte zu hosten, zu speichern, anzuzeigen und zu verarbeiten, soweit dies für den Betrieb und die Verbesserung des Dienstes erforderlich ist.',
      'Sie sind für die von Ihnen eingereichten Inhalte verantwortlich und bestätigen, dass Sie das Recht haben, sie zu teilen. Wir können Inhalte entfernen, die gegen diese Bedingungen oder geltendes Recht verstoßen.',
    ],
  },
  {
    title: WC2026_ORG_BILLING_TERMS_SECTION.title,
    paragraphs: [...WC2026_ORG_BILLING_TERMS_SECTION.paragraphs],
  },
  {
    title: 'Haftungsausschlüsse',
    paragraphs: [
      'Der Dienst wird „wie besehen“ und „wie verfügbar“ im größtmöglichen gesetzlich zulässigen Umfang bereitgestellt. Sportdaten, Quoten und Ergebnisse können von Dritten stammen; wir garantieren deren Genauigkeit oder Aktualität nicht.',
      'Freundschaftlicher Wettbewerb und Vorhersagen dienen der Unterhaltung. Nichts im Dienst stellt Glücksspiel-, Finanz- oder professionelle Beratung dar, wenn eine solche Tätigkeit reguliert oder verboten ist.',
    ],
  },
  {
    title: 'Haftungsbeschränkung',
    paragraphs: [
      'Im größtmöglichen gesetzlich zulässigen Umfang haften wir nicht für indirekte, beiläufige, besondere, Folge- oder Strafschäden oder für entgangenen Gewinn, Datenverlust oder Goodwill-Schäden, die aus Ihrer Nutzung des Dienstes entstehen.',
      'Unsere Gesamthaftung für Ansprüche aus dem Dienst ist begrenzt auf den höheren Betrag von (a) dem Betrag, den Sie uns in den zwölf Monaten vor dem Anspruch für den Dienst gezahlt haben, oder (b) einhundert US-Dollar (USD $100), sofern das Recht eine solche Obergrenze nicht ausschließt.',
    ],
  },
  {
    title: 'Freistellung',
    paragraphs: [
      'Sie erklären sich bereit, uns und unsere verbundenen Unternehmen, leitenden Angestellten und Mitarbeiter gegen Ansprüche, Schäden und Kosten (einschließlich angemessener Anwaltskosten) zu verteidigen und freizustellen, die aus Ihrer Nutzung des Dienstes, Ihren Inhalten oder Ihrem Verstoß gegen diese Bedingungen entstehen, soweit gesetzlich zulässig.',
    ],
  },
  {
    title: 'Anwendbares Recht und Streitigkeiten',
    paragraphs: [
      'Diese Bedingungen unterliegen den Gesetzen am Ort, an dem Zporti sein Geschäft betreibt, ohne Berücksichtigung kollisionsrechtlicher Regeln, sofern zwingende Verbraucherschutzvorschriften in Ihrem Land nichts anderes vorsehen.',
      'Wenn Sie Verbraucher sind, können Sie unter Umständen das Recht haben, Streitigkeiten vor den Gerichten Ihres Wohnsitzes anhängig zu machen, wenn dies gesetzlich vorgeschrieben ist.',
    ],
  },
  {
    title: 'Änderungen',
    paragraphs: [
      'Wir können diese Bedingungen von Zeit zu Zeit aktualisieren. Die aktualisierten Bedingungen veröffentlichen wir auf dieser Seite. Die fortgesetzte Nutzung des Dienstes nach Inkrafttreten von Änderungen gilt als Annahme der überarbeiteten Bedingungen, soweit gesetzlich zulässig.',
    ],
  },
  {
    title: 'Kontakt',
    paragraphs: [
      'Fragen zu diesen Bedingungen: info@zporti.com',
    ],
  },
]

const DE_CREDITS_SECTIONS: readonly LegalSection[] = [
  {
    title: 'Drittanbieter-Credits',
    paragraphs: [
      'Zporti verwendet ausgewählte Audio-Assets Dritter für Soundeffekte in der App.',
      'Sound-Assets stammen von Freesound und werden unter CC0-Lizenz (Public Domain) genutzt.',
    ],
  },
  {
    title: 'Icon-Attribution',
    paragraphs: [
      'Sport-Icons stammen von Flaticon und werden unter der kostenlosen Lizenz genutzt, die eine Namensnennung erfordert.',
      'Basketball icons created by justicon — Flaticon: https://www.flaticon.com/free-icons/basketball',
      'Soccer ball icons created by DinosoftLabs — Flaticon: https://www.flaticon.com/free-icons/soccer-ball',
    ],
  },
  {
    title: 'Audio-Attribution',
    paragraphs: [
      'Freesound: https://freesound.org/',
      'Creative Commons CC0 1.0: https://creativecommons.org/publicdomain/zero/1.0/',
    ],
  },
]

export const DE_LEGAL_SECTIONS = {
  privacy: DE_PRIVACY_POLICY_SECTIONS,
  dataDeletion: DE_DATA_DELETION_SECTIONS,
  terms: DE_TERMS_OF_SERVICE_SECTIONS,
  credits: DE_CREDITS_SECTIONS,
} as const
